<template>
  <PostEditorContainer :fetch-post-loading="fetchPostLoading">
    <template v-slot:contentField class="overflow-y: scroll">
      <PostBasicField />
      <PostContentField v-if="mode === 'edit' || mode === 'inspection'" />
      <PreviewPostContentField v-if="mode === 'readonly'" />
    </template>

    <template v-slot:rightToolBar>
      <template v-if="toolBarStatus === 'edit'">
        <InspectionController v-if="post.id != null" />
        <InspectionPreview v-if="post.id != null" />
        <PostController />
        <ProofreadBtn />
        <template v-if="order">
          <OrderRegulationCheckField />
          <OrderController />
        </template>
        <template v-else-if="post && post.savedRegulationBundlerId">
          <PostRegulationCheckField />
          <PostRegulationCheckSettingField />
        </template>
        <template v-else>
          <PostRegulationCheckSettingField />
        </template>
        <TagField />
        <WriterableField />
        <ExpertableField />
      </template>
      <template v-if="toolBarStatus === 'comment'">
        <CommentPostController />
        <CommentField />
      </template>
    </template>
  </PostEditorContainer>
</template>

<script>
import PostEditorContainer from '@/components/postEditor/layout/PostEditorContainer'
import PostBasicField from '@/components/postEditor/layout/PostBasicField'
import PostController from '@/components/postEditor/parts/PostController'
import WriterableField from '@/components/postEditor/parts/WriterableField'
import PostContentField from '@/components/postEditor/layout/PostContentField'
import TagField from '@/components/postEditor/parts/TagField'
import ExpertableField from '@/components/postEditor/parts/ExpertableField'
import InspectionController from '@/components/postEditor/parts/InspectionController'
import InspectionPreview from '@/components/postEditor/parts/InspectionPreview'
import OrderController from '@/components/postEditor/parts/OrderController'
import PreviewPostContentField from '@/components/postEditor/layout/PreviewPostContentField'
import OrderRegulationCheckField from '@/components/postEditor/parts/OrderRegulationCheckField'
import PostRegulationCheckField from '@/components/postEditor/parts/PostRegulationCheckField'
import PostRegulationCheckSettingField from '@/components/postEditor/parts/PostRegulationCheckSettingField'
import CommentField from '@/components/postEditor/parts/comments/CommentField'
import CommentPostController from '@/components/postEditor/parts/comments/PostController'
import headUtilsMixin from '@/mixins/head_utils'
import ProofreadBtn from '@/components/postEditor/parts/ProofreadBtn'
import { mapState } from 'vuex'

export default {
  components: {
    ProofreadBtn,
    PostEditorContainer,
    WriterableField,
    PostBasicField,
    PostController,
    PostContentField,
    TagField,
    ExpertableField,
    InspectionController,
    OrderController,
    PreviewPostContentField,
    OrderRegulationCheckField,
    PostRegulationCheckField,
    PostRegulationCheckSettingField,
    InspectionPreview,
    CommentField,
    CommentPostController
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '記事編集',
      fetchPostLoading: false,
      savedToDB: true
    }
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post,
      order: (state) => state.PostEditor.post.recentOrder,
      mode: (state) => state.PostEditor.mode,
      toolBarStatus: (state) => state.PostEditor.toolBarStatus
    })
  },
  mounted: async function () {
    this.fetchPostLoading = true
    const query = {
      postId: location.pathname
        .match(/\/posts\/\d*/)[0]
        .replace(/\/posts\//, '')
    }
    try {
      await this.$store.dispatch('PostEditor/fetchPost', query)
    } finally {
      this.fetchPostLoading = false
    }
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/SET_POST_SAVED_TO_DB') {
        this.savedToDB = !!mutation.payload
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.savedToDB) {
      next()
    } else {
      window.confirm('記事が保存されていません。このページを離れますか？')
        ? next()
        : next(false)
    }
  }
}
</script>
